// extracted by css-extract-rspack-plugin
export default {"FooterRedesignOffset":"SharedLayout-module__FooterRedesignOffset__sEqQj"};